import {createAction, props} from "@ngrx/store";
import {PaginatedRequestModel} from '@core/model/paginated-request.model';
import {PaginatedResultModel} from '@core/model/paginated-result.model';
import {Provider} from '@core/model/providers';
import {DatacenterV2} from '@core/model/datacenter-v2';

export const LOAD_PROVIDERS = '[Providers API] Load Providers';
export const PROVIDERS_LOADED = '[Providers API] Providers Loaded';
export const PROVIDERS_TO_DISPLAY_LOADED = '[Providers API] Providers to display Loaded';
export const PROVIDER_MODIFIED = '[Providers API] Provider Modified';
export const PROVIDER_COLOR_CHANGED = '[Providers API] Provider Color Changed';
export const DATACENTER_MODIFIED = '[Providers API] Datacenter Modified';
export const PROVIDERS_SAVED = '[Providers API] Providers Saved';
export const TOGGLE_VISIBILITY = '[Providers API] Toggle visibility';
export const NUKE_STORE = '[Providers API] Nuke Store';
export const PROVIDER_UNSELECTED = '[Providers API] Provided unselected';
export const LOAD_GLOBAL_PROVIDERS = '[Provider] Load Global Providers';
export const LOAD_GLOBAL_PROVIDERS_SUCCESS = '[Provider] Load Global Providers Success';
export const LOAD_GLOBAL_PROVIDERS_FAILURE = '[Provider] Load Global Providers Failure';
export const DELETE_GLOBAL_PROVIDER = '[Provider] Delete Global Provider';
export const DELETE_GLOBAL_PROVIDER_SUCCESS = '[Provider] Delete Global Provider Success';
export const DELETE_GLOBAL_PROVIDER_FAILURE = '[Provider] Delete Global Provider Failure';
export const GET_GLOBAL_PROVIDER = '[Provider] Get Global Provider';
export const GET_GLOBAL_PROVIDER_SUCCESS = '[Provider] Get Global Provider Success';
export const GET_GLOBAL_PROVIDER_FAILURE = '[Provider] Get Global Provider Failure';
export const SAVE_GLOBAL_PROVIDER = '[Provider] Save Global Provider';
export const SAVE_GLOBAL_PROVIDER_SUCCESS = '[Provider] Save Global Provider Success';
export const SAVE_GLOBAL_PROVIDER_FAILURE = '[Provider] Save Global Provider Failure';
export const GET_PROVIDERS_CONFIGURATION = '[Providers API] Get Providers Configuration';

export const getProvidersConfiguration = createAction(
  GET_PROVIDERS_CONFIGURATION,
  props<{ localProviders: Provider[], globalProviders: Provider[] }>()
)

export const providersToDisplayLoaded = createAction(
  PROVIDERS_TO_DISPLAY_LOADED,
  props<{ providers: Provider[] }>()
);

export const providersModified = createAction(
  PROVIDER_MODIFIED,
  props<{ provider: Provider }>()
);
export const loadProviders = createAction(
  LOAD_PROVIDERS,
  props<{ mapId: string }>()
);
export const providersLoaded = createAction(
  PROVIDERS_LOADED,
  props<{ providers: Provider[] }>()
);
export const datacenterModified = createAction(
  DATACENTER_MODIFIED,
  props<{ datacenter: DatacenterV2 }>()
);

export const providerColorChanged = createAction(
  PROVIDER_COLOR_CHANGED,
  props<{ provider: Provider }>()
);

export const toggleVisibility = createAction(
  TOGGLE_VISIBILITY,
  props<{ providers: Provider[], isVisible: boolean }>()
);

export const providersSaved = createAction(
  PROVIDERS_SAVED,
  props<{ providers: Provider[] }>()
);

export const providerUnselected = createAction(
  PROVIDER_UNSELECTED,
  props<{ provider: Provider }>()
);

export const nukeStore = createAction(
  NUKE_STORE
);

export const loadGlobalProviders = createAction(
  LOAD_GLOBAL_PROVIDERS,
  props<{ params: PaginatedRequestModel }>()
);

export const loadGlobalProvidersSuccess = createAction(
  LOAD_GLOBAL_PROVIDERS_SUCCESS,
  props<{ response: PaginatedResultModel<Provider> }>()
);

export const loadGlobalProvidersFailure = createAction(
  LOAD_GLOBAL_PROVIDERS_FAILURE
);
export const deleteGlobalProvider = createAction(
  DELETE_GLOBAL_PROVIDER,
  props<{ id: string }>()
);

export const deleteGlobalProviderSuccess = createAction(
  DELETE_GLOBAL_PROVIDER_SUCCESS,
);

export const deleteGlobalProviderFailure = createAction(
  DELETE_GLOBAL_PROVIDER_FAILURE,
  props<{ error: any }>()
);

export const getGlobalProvider = createAction(
  GET_GLOBAL_PROVIDER,
  props<{ id: string }>()
);

export const getGlobalProviderSuccess = createAction(
  GET_GLOBAL_PROVIDER_SUCCESS,
  props<{ provider: Provider }>()
);

export const getGlobalProviderFailure = createAction(
  GET_GLOBAL_PROVIDER_FAILURE,
  props<{ error: any }>()
);

export const saveGlobalProvider = createAction(
  SAVE_GLOBAL_PROVIDER,
  props<{ provider: Provider }>()
);

export const saveGlobalProviderSuccess = createAction(
  SAVE_GLOBAL_PROVIDER_SUCCESS,
  props<{ provider: Provider }>()
);

export const saveGlobalProviderFailure = createAction(
  SAVE_GLOBAL_PROVIDER_FAILURE,
  props<{ error: any }>()
);

